var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInterfaceNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_interface_notification",
    width: 20.4,
    height: 24,
    viewBox: "0 0 20.4 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-notifications-3662322",
    d: "M190.2,129.964a2.41,2.41,0,0,0,2.4-2.4h-4.8a2.41,2.41,0,0,0,2.4,2.4Zm8.65-6.353a2.888,2.888,0,0,1-.851-2.04v-5.409a7.79,7.79,0,0,0-5.31-7.385.994.994,0,0,1-.688-.941,1.848,1.848,0,0,0-1.749-1.871,1.8,1.8,0,0,0-1.853,1.8v.073a.994.994,0,0,1-.688.941,7.79,7.79,0,0,0-5.31,7.385v5.4a2.888,2.888,0,0,1-.851,2.04l-.7.7h0a2.914,2.914,0,0,0-.848,2.04h20.4a2.914,2.914,0,0,0-.848-2.04Z",
    transform: "translate(-179.998 -105.964)",
    fill: "#1049e5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterfaceNotification);
export default __webpack_public_path__ + "static/media/icon_interface_notification.4d7d20bf98017a34e6d740c9ec0d371c.svg";
export { ForwardRef as ReactComponent };